import {Button, Modal} from 'antd'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import React from 'react'
import {PiCheckCircleFill} from 'react-icons/pi'
import {NullAsDefault, renderSelf} from 'views/Shared'
import {renderIf} from "../../Shared"

export const willGoTo = ({
  url,
  item,
  icon,
  title,
  okText,
  content,
  cancelText,
  onOk = NullAsDefault,
  okButtonProps,
  ...props
}) => {
  if (item) {
    Modal.confirm({
      icon,
      title,
      okText,
      content,
      cancelText,
      okButtonProps,
      okType: 'primary',
      onOk: () => {
        onOk(_.isEmpty(url) ? getLinkToDetail(item) : url)
      },
      ...props,
    })
  }
}

export const confirmOnSuccess = ({
  title,
  content,
  description,
  translate = renderSelf,
  ...props
}) => {
  const modal = Modal.info({
    icon: null,
    centered: true,
    width: 360,
    style: {maxWidth: 'calc(100vw - 32px)'},
    className: 'success-confirm-modal',
    closable: false,
    footer: null,
    content: (
      <div className="flex flex-col items-center gap-5 pt-2 pb-2 text-center">
        <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center">
          <PiCheckCircleFill
            size={52}
            className="text-green-500"
          />
        </div>
        <div className="flex flex-col gap-2">
          <div className="font-bold text-lg text-green-600 leading-snug">
            {_.isString(title) ? translate(title) : title}
          </div>
          {renderIf(
            content,
            <div className="text-sm text-color-300 leading-relaxed">
              {_.isString(content) ? translate(content) : content}
            </div>
          )}
          {renderIf(
            description,
            <div className="text-xs text-color-400 italic leading-relaxed">
              {_.isString(description) ? translate(description) : description}
            </div>
          )}
        </div>
        <Button
          type="primary"
          size="large"
          block
          className="rounded-xl font-semibold"
          onClick={() => modal.destroy()}>
          {translate('close')}
        </Button>
      </div>
    ),
    ...props,
  })
  return modal
}
